import { forwardRef } from 'react';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}
/**
 * Helper function to create a special version of `React.forwardRef` that
 * also attaches some special icon metadata (the icon name and set).
 *
 * @param iconSet
 * @returns
 */


var makeForwardRef = function makeForwardRef(iconSet) {
  return function (component, iconName) {
    var hasAccent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var IconComponent = /*#__PURE__*/forwardRef(component);
    IconComponent.iconName = iconName;
    IconComponent.iconSet = iconSet;
    IconComponent.hoverIcon = true;
    IconComponent.hasAccent = hasAccent;
    return IconComponent;
  };
};

export { _extends as _, makeForwardRef as m };